import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ConfirmBox.css";
import Button from "../ButtonComponent/Button";
import PropTypes from "prop-types";

const ConfirmBox = ({
  show,
  setShow,
  title = "Are you sure ?",
  confirmMessage = "Confirm message",
  confirmFunc = () => {
    setShow(false);
  },
}) => {
  const handleClose = () => setShow(false);

  return (
    <div>
      <Modal show={show} onHide={handleClose} className="confirmBoxModal">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{confirmMessage}</Modal.Body>
        <Modal.Footer>
          <div className="buttonConfirm">
            <Button text={"Confirm"} onClick={() => confirmFunc()}></Button>
          </div>
          <div lassName="buttonCancel">
            <Button text={"Cancel"} onClick={() => handleClose()}></Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

ConfirmBox.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default ConfirmBox;
